import { Command } from 'commander';
import inquirer from 'inquirer';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { resolveUserIdByEmail } from '../_members-resolver.js';

interface RemoveOpts { skipConfirm?: boolean; org?: string; }

export async function runAdminRemove(email: string, opts: RemoveOpts, client?: IV2Client): Promise<void> {
  if (!opts.skipConfirm) {
    const { ok } = await inquirer.prompt([{ type: 'confirm', name: 'ok',
      message: `Remove ${email} from the grid? They lose access immediately. Owned nodes remain.`,
      default: false,
    }]);
    if (!ok) { process.stdout.write('Cancelled.\n'); return; }
  }
  const c = client ?? await getV2Client(opts.org ?? undefined);
  const userId = await resolveUserIdByEmail(c, email);
  await c.del(`/api/v2/members/${userId}`);
  process.stdout.write(`✓ Removed ${email} from the grid.\n`);
}

export const adminRemoveCommand = new Command('remove')
  .description('Remove a member from the grid (admin only)')
  .argument('<email>', 'Email of member to remove')
  .option('--skip-confirm', "Don't prompt")
  .option('--org <slug>', 'Override active grid')
  .action(async (email: string, opts: RemoveOpts) => {
    try { await runAdminRemove(email, opts); }
    catch (err) { await handleV2Error(err); }
  });
